query TagTypesAutocomplete(
  $input: String = ""
  $value: [ID!] = []
  $filter: AutocompleteTagTypesFilterInput
) {
  autocomplete: autocompleteTagTypes(
    input: $input
    value: $value
    filter: $filter
  ) {
    options {
      value
      label
    }
    value {
      value
      label
    }
  }
}
